import { FC } from 'react';

interface Props {
    color?: string;
}

const AvailableIcon: FC<Props> = ({ color }) => {
    return (
        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_8148_29801)">
                <path
                    d="M0 6.5C0 3.18629 2.68629 0.5 6 0.5C9.31373 0.5 12 3.18629 12 6.5C12 9.81373 9.31373 12.5 6 12.5C2.68629 12.5 0 9.81373 0 6.5Z"
                    fill={color ? color : '#009640'}
                />
                <path d="M3.33398 6.36667L5.0869 8.23333L8.66732 4.5" stroke="white" strokeWidth="1.5" />
            </g>
            <defs>
                <clipPath id="clip0_8148_29801">
                    <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default AvailableIcon;
